enum ProvidedServices {
    EntityService,
    EnvironmentService,
    DossierService,
    SocketService,
}

export default ProvidedServices
